import Router from "./Routes/Router";
import { AuthProvider } from './context/Auth';
import PWAInstallPrompt from './components/PWAInstallPrompt';
import '@tremor/react/dist/esm/tremor.css';

// ─────────────────────────────────────────────────────────────
// CONFIGURAÇÃO DE MANUTENÇÃO PROGRAMADA
//
// Como configurar:
//   brDate('AAAA-MM-DDTHH:mm') cria uma data no fuso de Brasília (UTC-3).
//   Defina MAINTENANCE_START e MAINTENANCE_END para exibir o banner.
//   Para OCULTAR o banner, defina ambas as constantes como null.
//
// Exemplos:
//   const MAINTENANCE_START = brDate('2026-07-01T22:00'); // 01/07/2026 às 22h (Brasília)
//   const MAINTENANCE_END   = brDate('2026-07-02T06:00'); // 02/07/2026 às 06h (Brasília)
//   const MAINTENANCE_START = null; // desativado
//   const MAINTENANCE_END   = null; // desativado
// ─────────────────────────────────────────────────────────────
function brDate(localDateTimeStr) {
    // Interpreta a string como horário de Brasília (UTC-3)
    return new Date(localDateTimeStr + '-03:00');
}

const MAINTENANCE_START = brDate('2026-06-13T19:00'); // ex: brDate('2026-07-01T22:00')
const MAINTENANCE_END   = brDate('2026-06-14T08:00'); // ex: brDate('2026-07-02T06:00')
const SITE_OFFLINE = true; // true = mostra só a imagem, false = comportamento normal

export default function App() {

  if (SITE_OFFLINE) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <img src="/img/edicao_encerrada.png" alt="Edição encerrada" style={{ maxWidth: '100%', height: 'auto' }} />
      </div>
    );
  }

  return (
    <AuthProvider>
        <Router maintenanceStart={MAINTENANCE_START} maintenanceEnd={MAINTENANCE_END} />
        <PWAInstallPrompt />
    </AuthProvider>
  );
};